import React from 'react';
import { useSelector } from 'react-redux';
import AssignAndSubmit from './AssignAndSubmit';
import ReviewAndReturn from './ReviewAndReturn';
import Complete from '../simple-action-center/Complete';
import { getDocumentsType } from '../../features/documents/selectors';
import { DocumentTemplateType } from '../../api-client/autogenerated';

interface MobileTaskStepProps {
  handleClose: () => void;
  currentIndex: number;
  isRfi?: boolean;
  isWcpr?: boolean;
  documentTitle?: string;
}

export default function MobileTaskStep(props: MobileTaskStepProps) {
  const { handleClose, isRfi = false, isWcpr = false, documentTitle, currentIndex } = props;

  const documentType = useSelector(getDocumentsType);
  const showCompleteStep = isRfi || documentType === DocumentTemplateType.PotentialChangeOrders;

  const getDialog = (num: number) => {
    if (num === 0 && !isRfi && !isWcpr) return <AssignAndSubmit handleClose={handleClose} />;
    if (num === 1)
      return (
        <ReviewAndReturn
          handleClose={handleClose}
          isRfi={isRfi}
          isWcpr={isWcpr}
          documentTitle={documentTitle}
        />
      );
    if (num === 2 && showCompleteStep)
      return <Complete handleClose={handleClose} documentTitle={documentTitle} />;
    return undefined;
  };

  return <div>{getDialog(currentIndex)}</div>;
}
